/* eslint-disable  class-methods-use-this */

import axios from 'axios'
import { TokenHelper } from 'src/presentation/helpers/token-helper/token-helper'
import { HttpRequest, HttpResponse } from '../../../data/protocols/http/http-client'

export class AxiosHttpClientNoRedirect {
  api: any

  constructor(private readonly baseUrl: string | undefined) {
    const api = axios.create()
    api.interceptors.response.use(this.handleSuccess, this.handleError)
    this.api = api
  }

  async request({
    headers, method, url, data, params, ...options
  }: HttpRequest): Promise<HttpResponse> {
    let axiosResponse

    try {
      const token = this.updateToken()
      axiosResponse = await this.api.request({
        url: this.baseUrl + url,
        method,
        data,
        headers: {
          ...token,
          ...headers,
        },
        params,
        ...options,
      })
    } catch (error: any) {
      axiosResponse = error.response
    }

    return {
      statusCode: axiosResponse.status,
      body: axiosResponse.data,
    }
  }

  updateToken = (): object => {
    try {
      const token = TokenHelper.get()
      if (token) {
        return {
          Authorization: `Bearer ${token}`,
        }
      }
      return {}
    } catch (_) {
      return {}
    }
  }

  handleSuccess = (response: any): object => response

  handleError = (error: { response: { status: any } }): Promise<object> => Promise.reject(error)

  redirectTo = (document: { location: object }, path: any): void => {
    // eslint-disable-next-line no-param-reassign
    document.location = path
  }
}
